import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { OnboardingModule } from "@webapp/shared/components/onboarding/onboarding.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { SuggestionStateIndicatorComponent } from "./suggestion-state-indicator.component";

@NgModule({
  imports: [CommonModule, UiIconModule, LocalizationModule, UiTooltipModule, OnboardingModule],
  declarations: [SuggestionStateIndicatorComponent],
  exports: [SuggestionStateIndicatorComponent],
})
export class PISuggestionStateIndicatorModule {}
